export default class ViewHappeningController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    happening
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.happening = happening;
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
